import DocumentService from '@/api/DocumentService'

export default {
  namespaced: true,

  state: {
    logs: [],
    files: [],
    activities: [],
  },

  mutations: {
    setData (state, { key, data }) {
      state[key] = data
    },
  },

  actions: {
    resetState({ commit }) {
      commit('setData', {
        key: 'logs',
        data: [],
      })
      commit('setData', {
        key: 'files',
        data: [],
      })
      commit('setData', {
        key: 'activities',
        data: [],
      })
    },
    async getLogList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getLogList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getLogList')

        const response = await DocumentService.getLogList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getLogList')

        result = response.data

        if (result.success) {
          commit('setData', {
            key: 'logs',
            data: result.data,
          })
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createLog ({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createLog') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createLog')

        const response = await DocumentService.createLog(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createLog')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateLog ({ commit }, { id, data }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateLog') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateLog')

        const response = await DocumentService.updateLog(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateLog')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateLogStatus ({ commit }, { id, data }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateLogStatus') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateLogStatus')

        const response = await DocumentService.updateLogStatus(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateLogStatus')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deleteLog ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deleteLog') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deleteLog')

        const response = await DocumentService.deleteLog(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deleteLog')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getAttachFileList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getAttachFileList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getAttachFileList')

        const response = await DocumentService.getAttachFileList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getAttachFileList')

        result = response.data

        if (result.success) {
          commit('setData', {
            key: 'files',
            data: result.data,
          })
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createAttachFile ({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createAttachFile') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createAttachFile')

        const response = await DocumentService.createAttachFile(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createAttachFile')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deleteAttachFile ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deleteAttachFile') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deleteAttachFile')

        const response = await DocumentService.deleteAttachFile(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deleteAttachFile')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getActivityList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getActivityList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getActivityList')

        const response = await DocumentService.getActivityList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getActivityList')

        result = response.data

        if (result.success) {
          commit('setData', {
            key: 'activities',
            data: result.data,
          })
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/Document.js